$(function () {
    let selectFun = function () {
      let timer = null
      if ($(window).width() < 591) {
        timer = setInterval(() => {
          if ($('.bndlr-inner-products-container .bndlr-product .bndlr-select-variant').length != 0) {
            $('.bndlr-inner-products-container .bndlr-product').each(function (index, item) {
              let select = $(item).find('.bndlr-select-variant').attr('style')
              if (select.indexOf('display') == -1) {
                $(item).find('.bndlr-product-qn-container').addClass('margin_bottom10')
              }
            })
          }
        }, 500);
        setTimeout(() => {
          clearInterval(timer)
        }, 50000);
      }else{
        $(item).find('.bndlr-product-qn-container').removeClass('margin_bottom10')
      }
    }
    selectFun()
    window.addEventListener('resize', selectFun)
    
    window.addEventListener("pageshow", function () {
    let u = navigator.userAgent;
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (sessionStorage.getItem("param")) {
      if (isIOS) {
        location.reload();
        sessionStorage.removeItem("param");
      } else {
        location.reload();
        sessionStorage.removeItem("param");
      }
    }
    });
  })